import Cookies from 'js-cookie'

const WeixinDomain = ".baoxiuguanjia.com"
const WeixinToken = "WeixinToken"
const WeixinConfigType = 'WeixinConfigType'
const WeixinConfigId = "WeixinConfigId"
const WeixinServicerCode = 'WeixinServicerCode'
const WeixinServicerCheckMobile = 'WeixinServicerCheckMobile'
const WeixinScanUrl = 'WeixinScanUrl'

const WeixinServicerName = 'WeixinServicerName';
const WeixinServicerLogo = 'WeixinServicerLogo';

const WeixinServicerHomePage='WeixinServicerHomePage';

const MobileWebAppSource = 'MobileWebAppSource'

const WeixinOauthUrl = 'WeixinOauthUrl'
const WeixinOpenId = 'WeixinOpenId'
const WeixinUnionId = 'WeixinUnionId'

const WeixinInvite = 'WeixinInvite'

const WeixinAgent = 'WeixinAgent'
const WeixinAlliance = 'WeixinAlliance'

const AGENT_LS = '211736'
const ALLIANCE_LS = '221710'




export function getUserToken() {
  return Cookies.get(WeixinToken,{ domain:WeixinDomain})
}

export function setUserToken(token) {
  return Cookies.set(WeixinToken, token,{ domain:WeixinDomain})
}

export function removeUserToken() {
  return Cookies.remove(WeixinToken,{ domain:WeixinDomain})
}

export function getWxConfigType() {
  return Cookies.get(WeixinConfigType,{ domain:WeixinDomain})
}

export function setWxConfigType(token) {
  return Cookies.set(WeixinConfigType, token,{ domain:WeixinDomain})
}

export function removeWxConfigType() {
  return Cookies.remove(WeixinConfigType,{ domain:WeixinDomain})
}


export function getWxConfigId() {
  return Cookies.get(WeixinConfigId,{ domain:WeixinDomain})
}

export function setWxConfigId(token) {
  return Cookies.set(WeixinConfigId, token,{ domain:WeixinDomain})
}

export function removeWxConfigId() {
  return Cookies.remove(WeixinConfigId,{ domain:WeixinDomain})
}


export function getScanUrl() {
  return Cookies.get(WeixinScanUrl,{ domain:WeixinDomain})
}

export function setScanUrl(token) {
  return Cookies.set(WeixinScanUrl, token,{ domain:WeixinDomain})
}

export function removeScanUrl() {
  return Cookies.remove(WeixinScanUrl,{ domain:WeixinDomain})
}

export function getWeixinServicerName() {
  return Cookies.get(WeixinServicerName, { domain:WeixinDomain })
}

export function getWeixinServicerLogo() {
  return Cookies.get(WeixinServicerLogo, { domain:WeixinDomain })
}

export function getWeixinServicerHomePage() {
  return Cookies.get(WeixinServicerHomePage, { domain:WeixinDomain })
}


export function getServicerCode() {
  return Cookies.get(WeixinServicerCode,{ domain:WeixinDomain})
}

export function setServicerCode(token) {
  return Cookies.set(WeixinServicerCode, token,{ domain:WeixinDomain})
}

export function removeServicerCode() {
  return Cookies.remove(WeixinServicerCode,{ domain:WeixinDomain})
}



export function getWxOauthUrl() {
  return Cookies.get(WeixinOauthUrl,{ domain:WeixinOauthUrl})
}

export function setInviteInfo(info) {
  return Cookies.set(WeixinInvite, info,{ domain:WeixinDomain})
}

export function getInviteInfo() {
  return Cookies.get(WeixinInvite, { domian:WeixinDomain})
}

export function getWxAgentCode(info) {
  let rs =  Cookies.get(WeixinAgent,{ domain:WeixinDomain})
  if(!rs){
    rs = AGENT_LS
  }
  return rs
}

export function getWxAllianceCode() {
  let rs =  Cookies.get(WeixinAlliance, { domian:WeixinDomain})
  if(!rs){
    rs = ALLIANCE_LS
  }
  return rs
}

export function getServicerCheckMobile(){
  return Cookies.get(WeixinServicerCheckMobile, { domian:WeixinDomain})
}


export function getMobileWebAppSource(){
  return Cookies.get(MobileWebAppSource,{ domain:WeixinDomain})
}



// WEBPACK FOOTER //
// ./src/store/cookie.js